import React from "react";
import { FOOTER_LINKS } from "../../data/mock";
import { Mail } from "lucide-react";

const LOGO_URL = "/logo-cropped.png";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src={LOGO_URL} alt="Thryvin'" className="footer-logo-image" />
            <p className="footer-tagline">Your AI coach — available on iPhone and Android.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Legal</h4>
              <ul>
                {FOOTER_LINKS.legal.map((link) => (
                  <li key={link.href}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Contact</h4>
              <ul>
                <li>
                  <a href={`mailto:${FOOTER_LINKS.contact.email}`} className="contact-link">
                    <Mail size={16} />
                    <span>{FOOTER_LINKS.contact.email}</span>
                  </a>
                </li>
                <li>
                  <a href={FOOTER_LINKS.contact.support}>Help &amp; support</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>{FOOTER_LINKS.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
